export const environment = {
  env: 'development',
  production: false,
  apiBaseUrl: 'https://api.dev.u-supp-u.ck1lab.net',
  awsS3BaseUrl: 'https://dev.u-supp-u.devkarte.jp/',
  ckPassRegister: 'https://dev2.pass.ck1lab.net/register',
  ckPassForgotPassword: 'https://dev2.pass.ck1lab.net/forgot-password',
};
